import script from "./SocialProfileList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialProfileList.vue?vue&type=script&setup=true&lang=ts"

import "./SocialProfileList.vue?vue&type=style&index=0&id=7ef6efdd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef6efdd"]])

export default __exports__